import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/Contract";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf';  
import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';

const formatDate = (dateString, t) => {
    const purchasedAtDate = new Date(dateString);
    const months = [
        t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'),
        t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};

const shouldShowMarketingConsentClause = (purchased_at) => {
    console.log('purchased_at in condition:', purchased_at);

    if (!purchased_at) return false;

    const purchasedAtDate = new Date(purchased_at);
    const startDate = new Date('2026-04-22T00:00:00');

    console.log('parsed:', purchasedAtDate, 'valid:', !Number.isNaN(purchasedAtDate.getTime()));
    console.log('show clause:', purchasedAtDate > startDate);

    if (Number.isNaN(purchasedAtDate.getTime())) return false;

    return purchasedAtDate > startDate;
};



let primaryColor = "#000"
let ltd = "___________________"
let sk = "___________________"
let email = "___________________"
let tel = "_____________" 
let BOGbankAccount = "___________________"
let TBCbankAccountGel = "___________________"
let TBCbankAccountUSD = "___________________"
let address = "___________________"
let director_position = "___________________"
let director = "___________________"
let director_pn = "___________________"
let danarti = "___________________"

if(baseFileURL === 'https://finance.automoby.ge') {
    primaryColor = "#235e82"
    ltd = "შ.პ.ს. „ავტომობი“"
    sk = "446977022" 
    email = "info@automoby.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 55 22 " 
    address = "დ.აღმაშენებლის 154, თბილისი " 
    BOGbankAccount = "GE74BG0000000533900476"
    TBCbankAccountGel = "___________________"
    TBCbankAccountUSD = "___________________"
    director_position = "დირექტორი"
    director = "ნინო ჩანადირი"
    director_pn = "01024069247"
    danarti = "https://automoby.ge/danarti.pdf"

} else if(baseFileURL === 'https://crm.aig.com.ge') {

    primaryColor = "#da0429" 
    ltd = "შ.პ.ს. „ავტო იმპორტ ჯორჯია“"
    sk = "406203120"
    email = "info@aig.com.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 12 13" 
    address = "გიორგი სააკაძის მე-2 შესახვევი ატრიუმის ბიზნესცენტრი, 1-ლი სართული თბილისი, 0160, საქართველო" 
    BOGbankAccount = "GE19BG0000000131217994"
    TBCbankAccountGel = "GE54TB7734536020100004"
    TBCbankAccountUSD = "GE17TB7734536120100007"
    director_position = "ადმინისტრაციული დეპარტამენტის ხელმძღვანელი"
    director = "მარიამ აქულაშვილი"
    director_pn = "01011091639"
    danarti = "https://autoimport.com.ge/wp-content/uploads/2019/10/Auto-aukcioni-A-mnishvn-pirobebi-21-05-19-2.pdf"
}

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    p0: { 
        marginBottom: '0px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 

});

 


const MyDocument = ({ car, t }) => (
    <Document>

        <Page size="A4" style={styles.page}>
 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px',}}>
                <Text>ავტოსატრანსპორტო საშუალების ნასყიდობის და მიწოდების ხელშეკრულება</Text> 
            </View>
  
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '7px'}}>
                <Text>თბილისი</Text> 
                <Text>{formatDate(car.purchased_at, t)}</Text> 
            </View>
  
            <Text style={styles.p}>
                ერთი მხრივ - {ltd} (ს.კ. {sk}) (შემდგომში „კომპანია“), ხელშეკრულებაში წარმოდგენილი ადმინისტრაციის დეპარტამენტის 
                ხელმძღვანელის {director}ს სახით (პ/ნ:{director_pn}) და  
                მეორეს მხრივ -  {car.client.firstname} {car.client.lastname} (პ# {car.client.personal}) 
                (შემდგომში „კლიენტი“) ვდებთ წინამდებარე ნასყიდობის ხელშეკრულებას შემდეგზე:
            </Text> 
    
 
            <Text style={styles.b}>
                ტერმინთა განმარტება: 
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>ნასყიდობის საგანი</Text>  - ამ ხელშეკრულების 1.2 პუნქტით განსაზრვრული ნივთი;
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>კომპანია</Text>  -  {ltd} ს/კ: {sk}, რომელიც კლიენტის მოთხოვნით და მასთან წინასწარი შეთანხმებით ყიდულობს ავტოსატრანსპორტო საშუალებას პირველადი მომწოდებლისგან, ახდენს მის რეალიზაციას  კლიენტზე და უზრუნველყოფს ავტოსატრანსპორტო საშუალების მიწოდებას ამ ხელშეკრულებით განსაზღვრული პირობებითა და წინასწარ შეთანხმებულ ადგილზე.
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>კლიენტი</Text>  - ამ ხელშეკრულებით განსაზრვრული ფიზიკური ან იურიდიული პირი, რომელიც მის მიერ შერჩეულ ავტოსატრანსპორტო საშუალებას, რომელიც კომპანიამ შეიძინა კლიენტის ან კომპანიის მიერ შერჩეული პირველადი მომწოდებლისგან, ყიდულობს კომპანიისგან.. 
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>მიწოდება</Text> - ავტოსატრანსპორტო საშუალების ტრანსპორტირების უზრუნველყოფა (INCOTERMS 2010 CIF პირობებით) კლიენტისთვის გადაცემის მიზნით ამ ხელშეკრულებით შეთანხმებულ ადგილამდე.
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>შეძენის ქვეყანა</Text> - ქვეყანა, სადაც კლიენტის მოთხოვნით და მასთან წინასწარი შეთანხმებით კომპანიის მიერ ხდება ავტოსატრანსპორტო საშუალების პირველადი შეძენა.
            </Text>  
            <Text style={styles.p0}>
                <Text style={styles.b}>პირველადი მომწოდებელი</Text> - ფიზიკური ან იურიდიული პირი, ვისაგანაც კომპანია ახორციელებს ავტოსატრანსპორტო საშუალების შეძენას, კლიენტზე შემდგომი რეალიზაციის მიზნით. 
            </Text> 


            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '10px', marginBottom: '10px', }}>
            პრეამბულა
            </Text> 

            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>მხარეები სრული პასუხისმგებლობით აცხადებენ, რომ მათ გააჩნიათ სრული სამართლებრივი უფლებამოსილება და ქმედუნარიანობა წინამდებარე ხელშეკრულების დასადებად და მის შესასრულებლად. ისინი ერთმანეთის უფლებებს პატივისცემით ეპყრობიან, მოქმედებენ კეთილსინდისიერად და საქართველოს კანონმდებლობის სრული დაცვით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>თითოეული მხარე სრულად აცნობიერებს მის მიერ ამ ხელშეკრულებით ნაკისრ უფლება-მოვალეობების არსს და მოცულობას. ისინი ადასტურებენ, რომ წინამდებარე  ხელშეკრულება ზუსტად გამოხატავს და სრულად შეესაბამება მათ ნებას. </Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>წინამდებარე ხელშეკრულება დადებულია მხარეთა მიერ ნებაყოფლობით, ხელმომწერ პირთა ან/და მესამე პირთა მხრიდან ძალადობის, მუქარის, მოტყუების, შეცდომის ან/და სხვა რაიმე უარყოფითი გარემოების გამოყენების გარეშე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>კლიენტისთვის ცნობილია, რომ {ltd} წარმოადგენს კომპანიას, რომელიც ეწევა კლიენტებისთვის მათ მიერ შერჩეული ავტოსატრანსპორტო საშუალებების შეძენას შესაბამისი მომწოდებლებისგან, როგორც საქართველოში, ასევე საქართველოს საზღვრებს გარეთ (სხვადასხვა  ელექტრონული პლატფორმებიდან, მათ შორის, საჯარო და დახურული ელექტრონული აუქციონებიდან, ფიზიკური და  იურიდიული პირებისგან), ასევე შეძენილი ავტოსატრანსპორტო საშუალებების მიწოდებას კლიენტისთვის საერთაშორისო კომერციული პირობების „INCOTERMS 2010“-ის CIF დებულებათა საფუძველზე,  ამ ხელშეკრულებით განსაზღვრულ, წინასწარ შეთანხმებულ ადგილამდე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>კლიენტისთვის ცნობილია, რომ წინამდებარე ხელშეკრულების საგანი - შეიძლება იყოს მეორადი  ან ახალი,  რომლებსაც არ მოყვება არანაირი ქარხნული გარანტია და რომ შეძენის მომენტში მასზე ოფიციალურად ხელმისაწვდომი ინფორმაცია შეიძლება არ შეესაბამებოდეს მის ფაქტობრივ მდგომარეობას. შესაბამისად, ის შეიძლება საჭიროებდეს აღდგენას, მათ შორის იმგავრ აღდგენას, რომლის მოლოდინიც კლიენტს არ ჰქონდა. შესაბამისად, კლიენტი ადასტურებს, რომ ხელშეკრულების საგნის მდგომარეობაზე (ტექნიკური და/ან მექანიკური გამართულობა (ძრავი, გადაცემათა კოლოფი), დაქოქვისა და/ან გადაადგილების უნარი, ელექტროსისტემის ფუნქციონირება და ა.შ.)  პასუხისმგებლობას სრულად იღებს საკუთარ თავზე და აცხადებს, რომ აღნიშნულთან დაკავშირებით კომპანიის  მიმართ არ ექნება  არანაირი პრეტენზია;</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>ვინაიდან წინამდებარე ხელშეკრულების დადებამდე, კომპანიამ  კლიენტის მოთხოვნით წინასწარ გაფორმებული დეპოზიტის ხელშეკრულების საფუძველზე, შეიძინა კლიენტის მიერ და/ან მასთან ერთად შერჩეული ავტოსატრანსპორტო საშაულება პირველადი მომწოდებლისგან, ამით კლიენტმა აიღო სრული ვალდებულება  უზრუნველყოს ამ ხელშეკრულების ყველა პირობის განუხრელად შესრულება. კლიენტმა ასევე აიღო ვალდებულება გადაიხადოს  ყველა ის გარეშე ხარჯი (საპორტო, სატერმინალო, მათზე დარიცხული ჯარიმების, საურავების და პირგასამტეხლოების და ა.შ ჩათვლით (არსებობის შემთხვევაში)), რომელიც აუცილებელია ავტოსატრანსპორტო საშუალების შეთანხმებულ ადგილამდე მიწოდებასა და კლიენტისთვის მისი ჩაბარებისთვის.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 4, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>•</Text><Text style={{textAlign: 'justify', }}>მხარეები თანხმდებიან, რომ ხელშეკრულების გაფორმებამდე მათ შორის არსებული ყველა მიმოწერა, ზეპირი ან/და წერილობითი კომუნიკაცია/შეთანხმება წარმოადგენს ამ ხელშეკრულების განუყოფელ ნაწილს, თუმცა მხარეები ადასტურებენ, რომ თუ ისინი წინააღმდეგობაში მოდის (მოდიან)  წინამდებარე ხელშეკრულების დებულებებთან, გამოიყენება ამ ხელშეკრულების დებულებები.</Text></View>


            <Text style={{  width: '100%',   marginTop: '10px', marginBottom: '10px', }}>
            მხარეები ვაფრომებთ წინამდებარე ხელშეკრულებას და ვთანხმდებით შემდეგზე:  
            </Text> 

            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '10px', marginBottom: '5px', }}>
                <Text style={styles.b}>1. </Text>  ხელშეკრულების საგანი
            </Text> 


            <Text style={styles.p0}>
                <Text style={styles.b}>1.1. </Text> წინამდებარე ხელშეკრულების საფუძველზე მხარეები თანხმდებიან, რომ კლიენტის მიერ შერჩეულ 1.2. პუნქტით განსაზღვრულ ავტოსატრანსპორტო საშუალებას კომპანია შეიძენს კლიენტის ან კომპანიის მიერ შერჩეული პირველადი მომწოდებლისგან და უზრუნველყოს მის მიწოდებას კლიენტისთვის საერთაშორისო კომერციული პირობების „INCOTERMS 2010“-ის (CIF) შესაბამისად,  1.3. პუნქტით შეთანხმებულ ადგილზე, ხოლო თავის მხრივ კლიენტი იღებს ვალდებულებას მიიღოს და ჩაიბარის ავტოსატრანსპორტო საშუალება, სრულად აუნაზღაუროს კომპანიას ავტოსატრანსპორტო საშუალების ღირებულება ამ ხელშეკრულებით დადგენილი წესით და პირობებით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>1.2. </Text> ნასყიდობის საგანს წარმოადგენს ავტოსატრანსპორტო საშუალება, რომლის მახასიათებლებია: 
            </Text>

            <Text style={styles.p0}>
                მარკა - <Text style={styles.b}> {car.maker && car.maker.name} </Text>, 
                მოდელი - <Text style={styles.b}> {car.model && car.model.name} </Text>,
                საიდენტიფიკაციო ნომერი (VIN): <Text style={styles.b}> {car.vin} </Text>,
                გამოშვების წელი -  <Text style={styles.b}> {car.prod_year && car.prod_year} </Text> (შემდგომში ასევე „ავტოსატრანსპორტო საშუალება“) 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>1.3. </Text> მხარეთა შეთანხმებით, ავტოსატრანსპორტო საშუალების მიწოდების ადგილია: საქართველოს, საბაჟო გამშვები პუნქტი/საბაჟო ტერმინალი, ქალაქი ფოთი/ბათუმი.
            </Text>
            

            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>2. </Text>  ავტოსატრანსპორტო საშუალების და მისი მიწოდების ღირებულება და ანგარიშსწორების წესი
            </Text> 


            <Text style={styles.p0}>
                <Text style={styles.b}>2.1. </Text> მხარეთა შეთანხმებით, ავტოსატრანსპორტო საშუალების ღირებულება განისაზღვრა - <Text style={styles.b}>{ 
                     
                            car.total_client_price
                        
                        } აშშ დოლარით</Text>;
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>2.2. </Text>  ავტოსატრანსპორტო საშუალების,  ღირებულება  მოიცავს ავტოსატრანსპორტო საშუალების შეძენის, ტრანსპორტირებისა და სატრანსპორტო რისკების დაზღვევის ხარჯებს, თუ ამ ხელშეკრულებით სხვა რამ არ არის გათვალისწინებული;
            </Text>
            
            

            <Text style={styles.p0}>
                <Text style={styles.b}>2.3. </Text>  წინამდებარე ხელშეკრულებით განსაზღვრული ფინანსური ვალდებულებების გადახდა მყიდელის მიერ ხორციელდება მხოლოდ და მხოლოდ უნაღდო ანგარიშსწორებით, ამ ხელშეკრულებაში მითითებულ საბანკო ანგარიშის ნომერებზე, რომელიც, ასევე ასახული იქნება კომპანიის მიერ წარდგენილ ინვოისში. სხვა სახით და/ან სხვა საბანკო რეკვიზიტებზე თანხის ჩარიცხვა და ანგარიშსწორება არ ჩაითვლება ავტოსატრანსპორტო საშუალების ღირებულების ან/და ამ ხელშეკრულებით გათვალისწინებული სხვა გადასახდელის ანგარიშში.
            </Text>
            
            

            <Text style={styles.p0}>
                <Text style={styles.b}>2.4. </Text>  საბანკო ანგარიშები, რომელზეც კლეინტის მიერ ხდება ფინანსური ვალდებულებების შესრულება:
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.4.1. </Text>  საქართველოს ბანკის ანგარიში: <Text style={styles.b}>{BOGbankAccount}</Text>  GEL /USD
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.4.2. </Text>  თიბისი ბანკის ანგარიში: <Text style={styles.b}>{TBCbankAccountGel}</Text> GEL
            </Text>
            
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.4.3. </Text>  თიბისი ბანკის ანგარიში: <Text style={styles.b}>{TBCbankAccountUSD}</Text> USD
            </Text>
            
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.5. </Text>  კლიენტი ვალდებულია არაუგვიანეს წინამდებარე ხელშეკრულების დადების დღეს კომპანიას გადაუხადოს ავტოსატრანსპორტო საშუალების ღირებულება წინასწარ შეთანხმებული პირობით, სრულად ან ნაწილობრივ. 
            </Text>
            
            
            <Text style={styles.p0}>
                <Text style={styles.b}>2.6. </Text>  თუ წინასწარი შეთანხმებით კლლიენტი გადაიხდის ნასყიდობის თანხის ნაწილს, მაშინ იგი ვალდებულია ავტოსატრანსპორტო საშუალების დარჩენილი ღირებულება დაფაროს ავტოსატრანსპორტო საშუალების მიწოდების ადგილზე შესვლის შესახებ შეტყობინების მიღებიდან არაუგვიანეს 4  (ოთხი) კალენდარული დღის განმავლობაში. ავტოსატრანსპორტო საშუალების შესაბამისი მიწოდების ადგილზე შესვლის შესახებ შეტყობინება კომპანიის მიერ შეიძლება განხორციელდს, როგორც წერილობითი, ასევე ზეპირი ფორმით. 
            </Text>
            
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>3. </Text> ტრანსპორტირება
            </Text> 
            
      
            <Text style={styles.p0}>
                <Text style={styles.b}>3.1. </Text> ტრანსპორტირება ხორციელდება კლიენტის ან კომპანიის მიერ შერჩეული  გადამზიდით, ტრანსპორტირებისათვის საჭირო გონივრულ ვადებში. 
            </Text>
      
            <Text style={styles.p0}>
                <Text style={styles.b}>3.2. </Text> კომპანია ვალდებულია სატრანსპორტო სივრცის (კონტეინერის) დაკომპლექტების შემდეგ, კლიენტის მოთხოვნით 15 დღის ვადაში მიაწოდოს მას შერჩეული სატრანსპორტო ორგანიზაციის კოორდინატები და კონტეინერის მაიდენტიფიცირებელი ნომერი;
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.3. </Text> ტრანსპორტირების ვადა დამოკიდებულია უშუალოდ გადამზიდ სატრანსპორტო კომპანიაზე. როგორც წესი, ტრანსპორტირების საშუალო მიწოდების გონივრული ვადა განისაზღვრება 90-120 სამუშაო დღით. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.4. </Text> ვინაიდან კომპანია თავად არ ახორციელებს გადაზიდვებს, ვინაიდან ტრანსპორტირება წარმოადგენს რთულ პროცესს და გადაზიდვის პროცესში შეიძლება ადგილი ჰქონდეს  სხვადასხვა გაუთვალისწინებელ დაბრკოლებას (პორტების გადატვირთვას, ავარიას, შეფერხებას და სხვა) აღნიშნული ვადა შეიძლება შემცირდეს ან გაიზარდოს არაუმეტეს 8 (რვა) კალენდარულ თვემდე, კომპანიისგან დამოუკიდებელი სხვადასხვა გარემოებიდან გამომდინარე, რაც ცნობილია კლიენტისთვის და აღნიშნულზე პრეტენზიას არ აცხადებს.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>3.4. </Text> კლიენტი აცხადებს და ადასტურებს, რომ კონტეინერის დაკომპლექტების წესი წინასწარ არის შეთანხმებული მასთან და პრეტენზიები კომპანიის მიმართ კონტეინერის დაკომპლექტების წესთან დაკავშირებით არ აქვს და არც მომავალში ექნება.
            </Text>
            


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>4. </Text> ავტოსატრანსპორტო საშუალების დაზღვევა
            </Text> 
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.1. </Text> თუ კლიენტი  ამ ხელშეკურლების გაფორმებამდე წინასწარი უარს არ განაცხადებს ავტოსატრანსპორტო საშუალების დაზღვევაზე, ასეთ შემთხვევაში ავტოსატრანსპორტო საშუალების დაზღვევა ძალაში შედის წინამდებარე ხელშეკრულების გაფორმებისთანავე და მოქმედებს ავტოსატრანსპორტო საშუალების დანიშნულების ადგილზე  შესვლისას, ტრანსპორტიდან ავტოსატრანსპორტო საშუალების გადმოტვირთვის დასრულებამდე.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>4.2. </Text> ავტოსატრანსპორტო საშუალების დაზღვევის შემთხვევაში, ავტოსატრანსპორტო საშუალების დაზღვევა ხორციელდება კომპანიის მიერ შერჩეული სადაზღვევო კომპანიის მიერ, სადაზღვევო კომპანიასთან წინასწარ შეთანხმებული სადაზღვევო პირობების მიხედვით, რომელიც ერთვის ამ ხელშეკრულებას N1 დანართის სახით (ტვირთის დაზღვევის პირობები სრული დაფარვა (A)). სადაზღვევო რისკის დადგომის შემთხვევაში პასუხისმგებლობას  ზიანის ანაზღაურებაზე აიღებს მზღვეველი კომპანია ტვირთის დაზღვევის პირობების შესაბამისად. 
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.3. </Text> კლიენტისთვის ცნობილია ის გარემოება, რომ იმ შემთხვევაში, თუ კლიენტი   უარს გნაცხადებს დაზღვევაზე და/ან კლიენტის წინასწარი ინფორმირებით არ ან ვერ ხერხდება ავტოსატრანსპორტო საშუალების დაზღვევა კომპანიისგან დამოუკიდებელი ან/და ობიექტური მიზეზებით, ასეთ შემთხვევაში სრული პასუხისმგებლობა ტრანსპორტირების დროს არსებულ რისკებზე ეკისრება კლიენტს.
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.4. </Text> ავტოსატრანსპორტო საშუალების მზღევველს წაროადგენს სს “სადაზღვევო კომპანია ჯიპიაი ჰოლდინგი" (ს/ნ: 204426674). დაზღვევის პირობები მოცემულია ამ ხელშეკრულების დანართ N1-ში (ტვირთის დაზღვევის პირობები სრული დაფარვა (A)), ასევე დაზღვევის პირობები მოცემულია შემდეგ ლინკზე {danarti}). ავტოსატრანსპორტო საშუალების დაზღვევის შემთხვევაში დანართი N1 წარმოადგენს წინამდებარე ხელშეკრულების განუყოფელ ნაწილს. წინამდებარე ხელშეკრულებაზე ხელმოწერით კლიენტი ადასტურებს, რომ ის თანახმაა ავტოსატრანსპორტო საშუალება ტრანსპორტირებისას კომპანიამ დააზღვიოს სს “სადაზღვევო კომპანია ჯიპიაი ჰოლდინგში" დანართი N1-ით განსაზღვრული პირობებით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>4.5. </Text> კლიენტისთვის ცნობილია, რომ კომპანია ამ შემთხვევაში წარმოადგენს დამზღვევს, ხოლო სადაზღვევო შემთხვევის დადგომისას სადაზღვევო ანაზღაურების გაცემაზე პასუხისმგებელ პირს წარმოადგენს მზღვეველი, რომელიც სადაზღვევო ანაზღაურებას გასცემს დანართ N1-ში მითითებულ სადაზღვევო რისკებისა და დანართის პირობების მიხედვით. კლიენტი ამ ხელშეკრულებაზე და მის დანართ N1-ზე ხელმოწერით ადასტურებს, რომ გაეცნო დაზღვევის პირობებს და ეთანხმება მას. 
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.6. </Text> სადაზღვევო შემთხვევის დაფიქსირების ინსტრუქცია მოცემულია დანართ N1-ში, რომელიც  ერთვის წინამდებარე ხელშეკრულებას და წარმოადგენს მის განუყოფელ ნაწილს. კლიენტი ვალდებულია სადაზღვევო შემთხვევის დადგომის შემთხვევაში იხელმძღვანელოს დანართი N1-ის დებულებებით, მათ შორის, განსაკუთრებული ყურადღება მიაქციოს დანართი N1-ის მე-18 და მე-19 მუხლებს.
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.7. </Text> კლიენტისთვის ცნობილია ის გარემოება, რომ სადაზღვევო შემთხვევის დაფიქსირების ინსტრუქციის დარღვევამ ან/და არაჯეროვნმა შესრულებამ შეიძლება გამოიწვეიოს სადაზღვევო პოლისის გაუქმება.
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.8. </Text> კლიენტისთვის ცნობილია, რომ კომპანიის მიერ მზღვეველისათვის წარდგენილ კლიენტის  საკონტაქტო ტელეფონის ნომრისა და ელექტრონული ფოსტის მისამართებზე მზღვეველის მიერ განხორციელდება სადაზღვევო ხელშეკრულებით გათვალისწინებულ მომსახურებასთან დაკავშირებული სხვადასხვა - მათ შორის პირდაპირ მარკეტინგთან დაკავშირებული, განსაკუთრებული მონაცემების შემცველი შეტყობინებების დაგზავნა, რაზეც კლიენტი აცხადებს თანხმობას და ადასტურებს, რომ მითითებული მიზნით მისი პერსონალური მონაცემების დამუშავებასთან დაკავშირებით პრტენზიები არ ექნება არც კომპანიასთან და არც დამზღვევთან.
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>4.9. </Text> კლიენტისთვის ცნობილია, რომ კომპანიის მიერ მზღვეველისათვის წარდგენილ კლიენტთა  საკონტაქტო ტელეფონის ნომრებსა და ელექტრონული ფოსტის მისამართებზე მზღვეველის მიერ განხორციელდება შეტყობინებების დაგზავნა პირდაპირი მარკეტინგის მიზნებისთვის ან კლიენტის პერსონალური მონაცემების გადაცემა მასთან აფილირებული/დაკავშირებული კომპანიებისთვის პირდაპირი მარკეტინგის მიზნებისთვის, რაზეც კლიენტი აცხადებს თანხმობას და ადასტურებს, რომ მითითებული მიზნით მისი პერსონალური მონაცემების დამუშავებასთან დაკავშირებით პრტენზიები არ ექნება;
            </Text>
            
            
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>5. </Text> ავტოსატრანსპორტო საშუალების საკუთრებაში და მფლობელობაში გადაცემა
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>5.1. </Text> ავტოსატრანსპორტო საშუალების საკუთრებაში გადაცამა გულისხმობს კლიენტისთვის ავტოსატრანსპორტო საშუალებაზე საკუთრების უფლების გადაცემას შეძენის ქვეყანაში ამ ხელშეკრულების გაფორმებისთანავე და ავტოსატრანსპორტო საშუალების   მიწოდებას ამ ხელშეკრულების 1.3. პუნქტით განსაზღვრულ ადგილზე და კლიენტისთვის შესაბამისი დოკუმენტების მომზადება/მიწოდებას.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>5.2. </Text> სამოქალაქო კოდექსის 482.1 მუხლის საფუძველზე მხარეები თანხმდებიან, რომ ავტოსატრანსპორტო საშუალების შემთხვევით დაღუპვისა და დაზიანების რისკი კომპანიიდან კლიენტზე გადადის წინამდებარე ხელშეკრულების მხარეთა მიერ ხელმოწერისთანავე. 
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>5.3. </Text> მხარეები თანხმდებიან, რომ კლიენტზე ავტოსატრანსპორტო საშუალების რეგისტრაციას და/ან მფლობელობაში გადაცემას მისთვის ან/და მის მიერ მითითებულ მესამე პირზე (უფლებამონაცვლეზე) კომპანია მოახდენს მხოლოდ მას შემდეგ, რაც სრულად და ჯეროვნად იქნება გადახდილი ავტოსატრანსპორტო საშუალების ღირებულება და სრულად და ჯეროვნად იქნება შესრულებული ყველა ის ვალდებულება (მათ შორის, ფინანსური), რაც გათვალისწინებულია წინამდებარე ხელშეკრულებით. 
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>5.4. </Text> კლიენტის მიერ ნაკისრი ვალდებულებების სრულად და ჯეროვნად შესრულებამდე კომპანია იტოვებს უფლებას არ გადასცეს ავტოსატრანსპორტო საშუალების რეგისტრაციისთვის აუცილებელი დოკუმენტები კლიენტს ან/და მის უფლებამონაცვლეს.
            </Text>
            
            
                        
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>6. </Text> ავტოსატრანსპორტო საშუალების მფლობელობაში გადაცემის წესი
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>6.1. </Text> კლიენტის მიერ ნაკისრი ვალდებულებების სრულად და ჯეროვნად შესრულების შემთხვევაში, ავტოსატრანსპორტო საშუალების კლიენტის მფლობელობაში გადაცემა ხორციელდება ამ ხელშეკრულების 1.3 პუნქტით შეთანხმებულ ადგილზე. 
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>6.2. </Text> კლიენტს უფლება აქვს ავტოსატრანსპორტო საშუალება მფლობელობაში მიიღოს როგორც პირადად, ასევე წარმომადგენლის მეშვეობით. 
            </Text>
            

            <Text style={styles.p0}>
                <Text style={styles.b}>6.3. </Text> თუ კლიენტის მიერ არ იქნება შესრულებული ან/და არაჯეროვნად იქნება შესრულებული  ამ ხელშეკრულებით განსაზღვრული ვალდებულებები, ავტოსატრანსპორტო საშუალება დარჩება კომპანიის მფლობელობაში და იმოქმედებს ხელშეკრულების 7.2. მუხლით განსაზღვრული დებულებები.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>6.4. </Text> კლიენტს უფლება აქვს მოითხოვოს ავტოსატრანსპორტო საშუალების მფლობელობაში გადაცემა მესამე პირისთვის ან/და მესამე პირის სახელზე რეგისტრაცია კომპანიისთვის წერილობითი განცხადების წარდგენის გზით.
            </Text>
            
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>7. </Text> მხარეთა უფლება-მოვალეობები
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>7.1. </Text> <Text style={styles.b}>კომპანიის ვალდებულებები:</Text> 
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>7.1.1. </Text> კომპანია ვალდებულია წინამდებარე ხელშეკრულებით დადგენილი პირობებით უზრუნველყოს ავტოსატრანსპორტო საშუალების შეძენა და მისი საექსპორტო თუ სხვა დოკუმენტების მომზადება.
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>7.1.2. </Text> კომპანია ვალდებულია წინამდებარე ხელშეკრულებით დადგენილი პირობებით უზრუნველყოს ავტოსატრანსპორტო საშუალების საკუთრებაში გადაცემა და მიწოდების ორგანიზება  კლიენტისთვის.
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>7.1.3. </Text> კომპანია პასუხს აგებს ავტოსატრანსპორტო საშუალების ტრანსპორტირების დროს დამდგარ ზიანზე, თუ ეს ზიანი უშუალოდ მისი ბრალეული ქმედებით არის გამოწვეული.
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>7.1.4. </Text> კომპანია ვალდებულია პერიოდულად მიაწოდოს ინფორმაცია კლიენტს  ავტოსატრანსპორტო საშუალების  ტრანსპორტირების (მიწოდების ) პროცესის შესახებ.
            </Text>
            
            <Text style={styles.p0}>
                <Text style={styles.b}>7.1.5. </Text> იმ შემთხვევაში, თუ შეთანხმებული ნასყიდობის ფასის ფარგლებში კომპანია ვერ ახერხებს პირველადი მომწოდებლისგან ავტოსატრანსპორტო საშუალების შეძენას ან/და ადგილი აქვს სხვა გაუთვალისწინებელ, კომპანიისგან დამოუკიდებელ დაბრკოლებებს, კომპანია იღებს ვალდებულებას სრულად დაუბრუნოს კლიენტს მისგან მიღებული თანხა. ასეთ შემთხვევაში კლიენტი აცხადებს და ადასტურებს, რომ ის არ მოითხოვს კომპანიისგან ზიანის ანაზრაურებას ან/და სხვა რაიმე სახის კომპენსაციას. 
            </Text>
             

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2. </Text> <Text style={styles.b}>კომპანიის  უფლებამოსილებანი:</Text> 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.1. </Text> კომპანია უფლებამოსილია დააზღვიოს ავტოსატრანსპორტო საშუალების სატრანსპორტო რისკები კლიენტთან შეთანხმებით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.2. </Text> კომპანია უფლებამოსილია კლიენტს არ გადასცეს ავტოსატრანსპორტო საშუალება და/ან მასთან დაკავშირებული დოკუმენტაცია მანამ, სანამ კლიენტის მიერ  სრულად და პირნათლად არ იქნება შესრულებული ამ ხელშეკრულებით ნაკისრი ვალდებულებები, მათ შორის სრულად არ იქნება დაფარული ავტოსატრანსპორტო საშუალების ღირებულება, ასევე ავტოსატრანსპორტო საშუალების შეძენასა და მის მიწოდებასთან დაკავშირებული ყველა თანმდევი ხარჯი, რომლიც გადასახდელია მესამე პირების მიმართ (აღნიშნულ ვალდებულებებსა და ხარჯებში იგულისხმება ყველა გადასახდელი, რომელიც დაკავშირებულია ავტოსატრანსპორტო საშუალების შეძენასთან, ტრანსპორტირებასთან, დაზღვევასთან, საპორტო, სატერმინალო, საბაჟო და საგადასახადო პროცედურებსა და მოსაკრებლებთან, ჯარიმებთან, საურავებთან, სახელმწიფო რეგისტრაციასთან და სხვა)
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.3. </Text> კლიენტის მიერ წინამდებარე ხელშეკრულებით დადგენილი წესით ავტოსატრანსპორტო საშუალების ღირებულების, გადაზიდვასთან  და საბაჟო რეგულაციებთან დაკავშირებული ხარჯების, ასევე სხვა ნებისმიერი თანმდევი ხარჯის გადაუხდელობის ან არაჯეროვნად გადახდის შემთხვევაში, ასევე ამ ხელშეკრულებით გათვალისიწნებული სხვა ნებისმიერი ვალდებულების შეუსრულებლობის ან არაჯეროვანი შესრულების შემთხვევაში, კომპანია უფლებამოსილია, არ გადასცეს ავტოსატრანსპორტო საშუალება კლიენტს, ცალმხრივად შეწყვიტოს წინამდებარე ხელშეკრულება, მოახდინოს ავტოსატრანსპორტო საშუალების საკუთარ სახელზე რეგისტრაცია (გაფორმება) და/ან მისი რეალიზაცია მესამე პირებზე. ასეთ შემთხვევაში კომპანია ასევე უფლებამოსილია პირგასამტეხლოს სახით დაიტოვოს კლიენტის მიერ ნასყიდობის ღირებულების ანგარიშში გადახდილი თანხიდან ავტოსატრანსპორტო საშუალების სრული ღირებულების 30% და ასევე ავტოსატრანსპორტო საშუალების საკუთარ სახელზე ან/და მესამე პირზე გადაფორმებასთან და/ან მის აღდგენა/რემონტთან დაკავშირებილი ხარჯები. აღნიშნული უფლებამოსილება კომპანიას წარმოეშობა ავტოსატრანსპორტო საშუალების ამ ხელშეკრულებით გათვალისწინებული მიწოდების ადგილზე შესვლიდან 20 (ოცი) კალენდარული დღის გასვლის შემდეგ, თუ ამ ხნის ვადაში კლიენტის მიერ არ იქნება შესრულებული ან/და არაჯეროვნად იქნება შესრულებული ყველა ფინანსური ვალდებულება, მათ შორის, თუ კლიენტის მიერ არაჯერვნად და/ან არასრულად იქნება გადახდილი ავტოსატრანსპორტო საშუალების საბაჟო ან/სხვა მსგავსი ტიპის სადგომზე დაყოვნებისთვის დარიცხული ჯარიმები, საურავები და გადასახდელები. 

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.4. </Text> კლიენტის მიერ ნაკისრი ვალდებულებების დარღვევისას, იმ შემთხვევაში თუ კომპანია ავტოსატრანსპორტო საშუალების ამ ხელშეკრულებით განსაზღვრული მიწოდების ადგილზე  შესვლიდან 20 კალენდარული დღის შემდეგ არ გამოიყენებს ხელშეკრულების შეწყვეტის  უფლებას, რომელიც მითითებულია 7.2.3. პუნქტში, კომპანია ასევე უფლებამოსილი იქნება წარმოშობილი დავალიანების უზრუნველყოფის მიზნით, ასევე ამ ხელშეკრულებით გათვალისიწნებული სხვა ნებისმიერი ვალდებულების შესრულების უზრუნველყოფის მიზნით გაავრცელოს მფლობელობითი გირავნობა არამხოლოდ ავტოსატრანსპორტო საშუალების მიმართ, არამედ ყველა იმ ავტოსატრანსპორტო საშუალების მიმართ,  რომელიც შეძენილია მხარეებს შორის გაფორმებული სხვა ხელშეკრულებების  ფარგლებში და რომლებიც იმყოფებიან კომპანიის მფლობელობაში;
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.5. </Text> მფლობელობითი გირავნობა ამოქმედებულად ჩაითვლება კომპანიის მიერ კლიენტისთვის წერილობითი ან ელექტრონული შეტყობინების გაგზავნის შემდეგ. იმ შემთხვევაში, თუ მფლობელობითი გირავნობის ამოქმედებიდან 3 (სამი) თვის გასვლის შემდეგ კლიენტის მიერ მაინც არ იქნება დაფარული ავტოსატრანსპორტო საშუალების ღირებულება, ასევე მის მიწოდებასთან დაკავშირებული ნებისმიერი სხვა ხარჯი/მოსაკრებელი, ავტოსატრანსპორტო საშუალების განბაჟების ან/და სახელმწიფო რეგისტრაციის ან/და მის აღდგენა/რემონტთან დაკავშირებილი  ხარჯები, კომპანია უფლებამოსილი იქნება საკუთარი შეხედულებისამებრ მოითხოვოს გირავნობის საგნის (ავტოსატრანსპორტო საშუალების) რეალიზაცია საბაზრო ფასად ანდა საკუთრებაში მიქცევა. წინამდებარე მუხლის მიზნებისთვის საბაზრო ფასად მიიჩნევა ფასი, რა ფასადაც არაგონივრული დაყოვნების გარეშე შესაძლებელი იქნება ავტომობილის რეალიზაცია.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.2.5. </Text> თუ გირავნობის საგნის (ავტოსატრანსპორტო საშუალების) რეალიზაციისას ამონაგები თანხა არ იქნება საკმარისი კომპანიის მოთხოვნების და ყველა ხარჯის სრულად დასაფარავად, ან გირავნობის საგნის საკუთრებაში მიღებისას გირავნობის საგნის ღირებულების ოდენობიდან გამომდინარე, თუ არ მოხდება მოთხოვნის და ხარჯების სრულად დაკმაყოფილება, კომპანიის, როგორც მოგირავნის მოთხოვნა არ ჩაითვლება დაკმაყოფილებულად და მას უფლება ექნება თავისი მოთხოვნის ან/და ხარჯების სრულად დაკმაყოფილების მიზნით მოითხოვის აღსრულების მიქცევა კლიენტის ნებისმიერ ქონებაზე 
            </Text>



            <Text style={styles.p0}>
                <Text style={styles.b}>7.3. </Text> <Text style={styles.b}>კლიენტის  ვალდებულებები:</Text> 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.3.1. </Text> კლიენტი ვალდებულია უზრუნველყოს ავტოსატრანსპორტო საშუალების ღირებულების, მისი მიწოდების და მისი თანმდევი ხარჯების (საპორტო, სატერმინალო, საბაჟო/საგადასახდო მოსაკრებლები, სახელმწიფო რეგისტრაციასა და სახელმწიფო ნომრების შეძენასთან დაკავშირებული გადასახდელები,) გადახდა ჯეროვნად და სრულად, წინამდებარე ხელშეკრულებით დადგენილი წესით. კლიენტი ვალდებულია, ასევე შეასრულოს სხვა ნებისმიერი და ყველა ფინანსური ვალდებულება, რომელიც დაკავშირებულია ავტოსატრანსპორტო საშუალებასთან და მის მიწოდებასთან.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.3.2. </Text> ავტოსატრანსპორტო საშუალების  დანიშნულების ადგილზე შესვლის შემდეგ კლიენტმა ამ ხელშეკრულებით და შესაბამისი კანონმდებლობით განსაზღვრულ ვადებში უნდა უზრუნველყოს ავტოსატრანსპორტო საშუალების ჩაბარება (მიღება). აღნიშნული ვალდებულების შეუსრულებლობის ან არაჯერვნად შესრულების შემთხვევაში წარმოშობილ ნებისმიერ ხარჯზე, ჯარიმაზე, მოსაკრებელზე, პირგასამტეხლოზე, საურავზე და ასევე ნებისმიერი სხვა ტიპის გადასახდელზე სრული პასუხისმგებლობა ეკისრება კლიენტს. გაუგებრობის და ბუნდოვანების თავიდან აცილების მიზნით მხარეები აცხადებენ და თანხმდებიან, რომ კლიენტი ამ პუნქტში წარმოშობილ ხარჯებზე (ზიანზე) პასუხისმგებელია ნებისმიერ შემთხვევაში ნებისმიერი პირის წინაშე, მიუხედავად იმისა, თუ უშუალოდ ვის მიადგება ზიანი. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.3.3. </Text> მხარეები თანხმდებიან, რომ ავტოსატრანსპორტო საშუალების ამ ხელშეკრულებით განსაზღვრულ ადგილზე შესვლის შემდეგ წარმოშობილ ყველა ფინანსურ და სხვა სახის ვალდებულებაზე პასუხისმგებელია  კლიენტი.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.3.4. </Text> კლიენტი ვალდებულია ავტოსატრანსპორტო საშუალების ფაქტობრივად ფლობის პერიოდში (თუ ამას ადგილი ჰქონდა ყველა ხარჯის და ფინანსური ვალდებულების შესრულებამდე) უზრუნველყოს სატრანსპორტო საშუალებაზე ზრუნვა განსაკუთრებული  გულისხმიერებით და აიღოს  სრული პასუხისმგებლობა  მისი დაზიანებით ან განადგურებით გამოწვეულ  ზიანზე, ასევე ამ ავტომობილის საშუალებით მესამე პირებისთვის მიყენებულ ზიანზე. ამ ვალდებულებათა შესრულების უზრუნველყოფის მიზნით, ის წარმოადგენს  სოლიდარულ მოვალეს უშუალოდ დარღვევის ჩამდენ ან სხვა პასუხისმგებელ პირთან ერთად (ასეთის არსებობის შემთხვევაში);

            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>7.3.5. </Text> კლიენტი ვალდებულია კომპანიას მიაწოდოს აქტიური საკონტაქტო ინფორმაცია და ამ ინფორმაციის ნებისმიერი ცვლილების შემთხვევაში, შეატყობინოს კომპანიას ცვლილების შესახებ.
            </Text>

            




            <Text style={styles.p0}>
                <Text style={styles.b}>7.4. </Text> <Text style={styles.b}>კლიენტის უფლებამოსილებები:</Text> 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.1. </Text> კლიენტი უფლებამოსილია კომპანიას მოსთხოვოს წინამდებარე ხელშეკრულების პირობების ჯეროვანი შესრულება.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.2. </Text> კლიენტი უფლებამოსილია კომპანიას მოსთხოვოს  ავტოსატრანსპორტო საშუალების  ტრანსპორტირების  შესახებ ინფორმაცია.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.3. </Text> კლიენტს უფლება აქვს მოითხოვოს ავტოსატრანსპორტო საშუალების გადაცემა მის მიერ მითითებულ მესამე პირზე.
            </Text>
 
            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.4. </Text> კლიენტი უფლებამოსილია მოითხოვის დეპოზიტის უკან დაბრუნება თუ კომპანიის მხრიდან ვერ მოხდა ავტოსატრანსპორტო საშუალების შეძენა პირველადი მომწოდებლისგან.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.5. </Text> კლიენტი უფლებამოსილია კომპანიას მოსთხოვოს ამ ხელშეკრულებით განსაზღვრულ ვალდებულებათა შეუსრულებლობით ან/და არაჯეროვანი შესრულებით წარმოშობილი ზიანის ანაზღაურება.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.6. </Text> კლიენტი უფლებამოსილია წინასწარ უარი განაცხადოს კომპანიის მიერ შეთავაზებულ დაზღვევაზე და არ დააზღვის ავტოსატრანსპორტო საშუალების სატრანსპორტო რისკები.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>7.4.7. </Text> კლიენტი, ასევე უფლებამოსილია თავად შეარჩიოს სადაზღვევო კომპანია და თავად მოახდინოს ავტოსატრანსპორტო საშუალების დაზღვევა.
            </Text>

            


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>8. </Text> კომპანიის პასუხისმგბელობის ფარგლები
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>8.1. </Text>  ვინაიდან კომპანია ავტოსატრანსპორტო საშუალებას ყიდულობს კლიენტის მიერ წინასწარი შერჩევით და მასთან შეთანხმებით პირველადი მომწოდებლისგან და ყიდის მასზე, ვინაიდან  ავტოსატრანსპორტო საშუალება წარმოადგენს მეორად (ექსპლუატაციაში ნამყოფი) სატრანსპორტო საშუალებას, რომელზეც არ ვრცელდება არანაირი ქარხნული ან/და სხვაგვარი გარანტია, ვინაიდან შესაძლებელია იგი იყოს ნაავარიები, აღდგენილი, ტექნიკურად და ელექტრულად გაუმართავი,  ვინაიდან ავტოსატრანსპორტო საშუალების შეძენა ხდება იმ მდგომარეობით და აღწერილობით, რა მდგომარეობაშიც ის არის გასაყიდად გამოტანილი პირველადი მომწოდებლის მიერ, ვინაიდან სატრანსპორტო საშუალების სურათები, აღწერილობა, ტექნიკური მახასიათებლები, გარბენი და სხვა მონაცემები, მოწოდებულია/განთავსებულია პირველადი მომწოდებლის მიერ, ვინაიდან კომპანიისთვის არ არის ხელმისაწვდომი და ცნობილი არანაირი დაზუსტებული ინფორმაცია ავტოსატრანსპორტო საშუალების შესახებ, ვინაიდან  წინასწარ უცნობია, სატრანსპორტო საშუალება დააკმაყოფილებს თუ არა საქართველოს კანონმდებლობით დადგენილ იმ სტანდარტებს, რომელიც საჭიროა სატრანსპორტო საშუალების გაფორმებისა და ფუქნციონირებისთვის, ვინაიდან კომპანიისთვის წინასწარ უცნობია სატრანსპორტო საშუალების ზუსტი სარეგისტრაციო ან/და გამოშვების წელი, განბაჟებისა და რეგისტრაციის საფასური, ასევე უცნობია მისი საერთაშორისო სამართლებრივი სტატუსი და ვინკოდის ავთენტურობა, შესაბამისად კომპანიის პასუხისმგებლობა შემოიფარგლება მხოლოდ და მხოლოდ ამ ხელშეკრულების 8.6. პუნქტით განსაზღვრული ვალდებულებებით, რაც კლიენტისთვის თავშივე ცნობილია და ის აღნიშნულზე პრეტენზიას არ აცხადებს და არც მომავალში არ განაცხადებს.

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.2. </Text>  ზემოაღნიშნული 8.1. პუნქტის დებულებები ვრცელდება იმ შემთხვევაზეც, თუ ავტოსატრანსპორტო საშუალება წარმოადგენს ახალ ავტოსატრანსპორტო საშუალებას, იმის გათვალისწინებით, რომ არც ახალ ავტოსატრანსპორტო საშუალებას არ მოჰყვება არანაირი ქარხნული გარანტია. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3. </Text>  ზემოაღნიშნულ გარემოებათა შესაბამისად:
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3.1. </Text>  კომპანია არ იღებს არანაირ პასუხისმგებლობას ავტოსატრანსპორტო საშუალების ტექნიკურ/მექანიკურ მდგომარეობასა და გამართულობაზე, მათ შორის, ძრავზე, გადაცემათა კოლოფზე, გარბენის სიზუსტეზე, ელექტროობის სიტემაზე, ელემეტებზე (არსებობის შემთხვევაში) და სხვა შემადგენლებზე,  რაზეც კლიენტი თავიდანვე ინფორმირებულია;
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3.2. </Text>  კომპანია არ არის პასუხისმგებელი იმ ინფორმაციის (სატრანსპორტო საშუალების ტექნიკური  მახასიათებლების, ვიზუალური მაჩვენებლების, მათ შორის, თუ ვიზუალური მაჩვენებლები არ ჩანს ფოტოსურათზე სრულყოფილად გადაღების რაკურსის, სინათლის, წვიმის, წყლის, ნესტის და/ან სხვა გარემოებების გამო, გამოშვების თარიღის, კომპლექტაციის, დაქოქვის ან /და სიარულის სტატუსის, ასევე სხვა ინფორმაციის)  სისწორეზე,  რომელიც  განთავსებულია/გავრცელებულია პირველადი მომწოდებლის მიერ იმ ვებ–გვერდ(ებ)ზე ან/და სხვა საშუალებებზე, საიდანაც  ხდება კლიენტის მიერ ავტომობილის შერჩევა და კომპანიის მიერ მისი შესყიდვა.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3.3. </Text>  კომპანია არ იღებს პასუხისმგებლობას ავტოსატრანსპორტო საშუალების დანიშნულებისამებრ ვარგისიანობაზე ან/და მასზე ხელმისაწვდომი ინფორმაციის სისწორეზე ან/და ავტოსატრანსპორტო საშუალებასთან დაკავშირებულ ნებისმიერ სხვა საკითხზე; 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3.4. </Text>   კომპანია არ იღებს პასუხისმგებლობას ავტოსატრანსპორტო საშუალების შიგნით მოთავსებულ ცალკეულ ნივთებსა და სათადარიგო ნაწილებზე, მათ შორის, გასაღებზე ასევე ავტოსატრანსპორტო საშუალებიდან არამართლზომიერი გზით მოხსნილ (დაკარგულ, მოპარულ) ცალკეულ ავტონაწილებზე. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.3.5. </Text> ავტოსატრანსპორტო საშუალების გადაზიდვის (ტრანსპორტირების) დროს კომპანიის პასუხისმგებლობა შემოიფარგლება  მხოლოდ საერთაშორისო კომერციული პირობების INCOTERMS 2010-ის CIF დებულებებით.  
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.4. </Text> მხარეები თანხმდებიან, რომ ავტოსატრანსპორტო საშუალების ვარგისიანობაზე, მდგომარეობაზე, მის  ტექნიკურ, მექანიკურ თუ ელქტრო გამართულობაზე, ასევე ტრანსპორტირების დროს გაუთვალისწინებელ შემთხვევებსა და რისკებზე  სრულ  პასუხისმგებლობას საკუთარ თავზე იღებს კლიენტი, გარდა იმ შემთხვევისა, თუ ზემოაღნიშნული გამოწვეულია უშუალოდ კომპანიის ბრალეული ქმედებით. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.5. </Text> ზემოაღნიშნულ დებულებათა გათვალისწინებით მხარეები თანხმდებიან, რომ ავტოსატრანსპორტო საშუალება იმ მდგომარეობით, რა მდგომარეობაშიც იგი არის კომპანიის მიერ შეძენის დროს და ასევე რა მდგომარეობაშიც იქნება ის ტრანსპორტირების დასრულებისას, კლიენტის მიერ საკუთრებაში (მფლობელობაში) მიღების დროს, წინამდებარე ხელშეკრულების მიზნებისთვის წარმოადგენს ნივთობრივად და უფლებრივად უნაკლო ნივთს. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.6. </Text> ზემოაღნიშნული პუნქტების გათვალისწინებით, კომპანიის პასუხისმგებლობა ვრცელდება მხოლოდ  ავტოსატრანსპორტო საშუალების შეძენაზე და მიწოდებისთვის აუცილებელი მოქმედებების განხორციელებაზე;
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.7. </Text> წინამდებარე მუხლის განსაზღვრებათა გათვალისწინებით, მხარეები თანხმდებიან, რომ:
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.7.1. </Text> სატრანსპორტო საშუალების ფაქტობრივი  მდგომარეობა შეიძლება არ ემთხვეოდეს სატრანსპორტო საშუალების იმ მდგომარეობას, რომელიც კლიენტმა ივარაუდა ამ სატრანსპორტო საშუალების დისტანციურად  შერჩევისას, თუმცა აღნიშნული არ გულისხმობს, რომ კლიენტმა შეცდომით გამოავლინა ნება, ვინაიდან მისთვის წინასწარ ცნობილია დისტაციურად ავტოსატრანსპორტო საშუალების შერჩევის, შეძენისა და ასევე მის ტრანსპორტირებასთან დაკავშირებული რისკები, რომლებზეც სრული პასუხისმგებლობა მას აკისრია.

            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.7.2. </Text>  ზემოაღნიშნულის შესაბამისად, კლიენტი ნებისმიერ შემთხვევაში არ წაურდგენს არანაირ პრეტენზიას კომპანიას ავტოსატრანსპორტო საშუალებასთან დაკავშირებით და იღებს ვალდებულებას, რომ არც მომავალში არ დააყენებს ამგვარ პრეტენზიას/მოთხოვნას კომპანიის მიმართ.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>8.7.3. </Text>  კლიენტი კომპანიას არც მომავალში წარუდგენს პრეტენზიას ავტოსატრანსპორტო საშუალების მდგომარეობასა და გამართულობასთან დაკავშირებით, ან ისეთ დაზიანებასთან დაკავშირებით, რომელიც ავტოსატრანსპორტო საშუალებას გააჩნდა მის შეძენამდე;   
            </Text>


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>9. </Text> მხარეთა პასუხისმგებლობა
            </Text> 
            
            <Text style={styles.p0}>
                <Text style={styles.b}>9.1. </Text>  მხარეები პასუხს აგებენ ერთმანეთისთვის ბრალეული ქმედებით მიყენებული ნებისმიერი ზიანისთვის.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>9.2. </Text>  იმ შემთხვევაში, თუ კლიენტი დაარღვევს ავტოსატრანსპორტო საშუალების ღირებულების ამ ხელშეკრულებით დადგენილ გადახდის პირობებს, ასევე თუ კლიენტი არ გადაიხდის ან არასრულად გადაიხდის წინამდებარე ნასყიდობის ხელშეკრულებით განსაზღვრულ ნებისმიერი სახის სხვა გადასახდელს ამგვარი გადასახდელის გადახდის წარმოშობის ვალდებულებიდან არაუგვიანეს 3 (სამი) კალენდარული დღის განმავლობაში,  კომპანია უფლებამოსილი იქნება კლიენტისგან მოითხოვოს პირგასამტეხლო გადასახდელი თანხის 0,06% ოდენობით ყოველ ვადაგადაცილებულ დღეზე. 
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>9.3. </Text>  მხარეები თანხმდებიან, რომ ხელშეკრულებით  გათვალისწინებული კლიენტის ყოველი და ნებისმიერი ვალდებულების დროულად და ჯეროვნად შესრულების უზრუნველყოფის საშუალებას წარმოადგენს არამხოლოდ ამ ხელშეკრულებით გათვალისწინებული ავტოსატრანსპორტო საშუალებები, არამედ ყველა ის ავტომობილი, რომელიც შეძენილია მხარეებს შორის გაფორმებული სხვა ხელშეკრულებების  ფარგლებში.
            </Text>

             

            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>10. </Text> ფორს-მაჟორი
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>10.1. </Text>  მხარეებს არ დაეკისრებათ პასუხისმგებლობა ხელშეკრულებით განსაზღვრული ვალდებულებების შეუსრულებლობის გამო, თუ ეს გამოწვეულია დაუძლეველი გარემოებების შედეგად, როგორიცაა ომი და საომარი მოქმედებები, სამოქალაქო არეულობა, ბუნებრივი კატაკლიზმები, მათ შორის, წყალდიდობები, მიწისძვრები, მეწყერები, ქარიშხლები, შტორმები, ასევე ხანძრი, გაფიცვი, სამხედრო მოქმედებები, ბლოკადა, სახელმწიფო და მუნიციპალური ორგანოების მიერ გამოცემული აქტები, პანდემია, ეპიდემია და სხვა ისეთი გარემოებები, რომლებიც მხარეთა კონტროლს მიღმაა და რომლებიც პირდაპირ ზემოქმედებენ მათ მიერ ნაკისრ ვალდებულებების შესრულებაზე [ფორს-მაჟორული გარემოებები].
            </Text>

             
            <Text style={styles.p0}>
                <Text style={styles.b}>10.2. </Text>  მხარე, რომელიც ფორს-მაჟორული გარემოების გამო ვერ ახერხებს ხელშეკრულებით ნაკისრი ვალდებულების შესრულებას, ვალდებულია ამგვარი გარემოებების დადგომისას დაუყოვნებლივ შეატყობინოს მეორე მხარეს.
            </Text>

            
             
            <Text style={styles.p0}>
                <Text style={styles.b}>10.3. </Text>  ფორს-მაჟორული გარემოებების დადგომისას მხარეების მიერ ხელშეკრულებით განსაზღვრული ვალდებულებების შესრულება გადაიდება ფორს-მაჟორული გარემოებების დასრულებამდე. 
            </Text>

            

            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>11. </Text> ხელშეკრულების მოქმედების ვადა და მისი შეწყვეტა
            </Text> 

             
            <Text style={styles.p0}>
                <Text style={styles.b}>11.1. </Text>  ხელშეკრულება ძალაში შედის მხარეთა მიერ ხელმოწერის დღიდან და მოქმედებს ნაკისრი ვალდებულებების სრულად და ჯეროვნად შესრულებამდე.
            </Text>
            
             
            <Text style={styles.p0}>
                <Text style={styles.b}>11.2. </Text>  ხელშეკრულება მოქმედება შეიძლება დასრულდეს წინამდებარე ხელშეკრულებით განსაზღვრულ შემთხვევებში და დადგენილი წესით  კლიენტის მიერ ნაკისრი ვალდებულებების შეუსრულებლობის ან არაჯეროვნად შესრულების შემთხვევაში.
            </Text>
            
             
            <Text style={styles.p0}>
                <Text style={styles.b}>11.3. </Text>  ხელშეკრულება შეიძლება შეწყდეს ასევე მხარეთა ურთიერთშეთანხმებით.
            </Text>
            

            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>12. </Text> დავების გადაწყვეტა
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>12.1. </Text>  ნებისმიერი დავა, წარმოშობილი წინამდებარე ხელშეკრულებასა და/ან მისი დანართ(ებ)თან დაკავშირებით, მათ შორის ნებისმიერი საკითხი ხელშეკრულების ან/და საარბიტრაჟო შეთანხმების არსებობის, ნამდვილობასა და შეწყვეტის შესახებ განხილვისა და საბოლოო გადაწყვეტილების მიღების მიზნით უნდა გადაეცეს მუდმივმოქმედ არბიტრაჟს „დავების განმხილველ ცენტრს“ DRC-ს. საარბიტრაჟო განხილვის ადგილია საქართველო თბილისი, რომლის სარეგისტრაციო კოდია 204547348, მის: ქ თბილისი ვაჟა-ფშაველას 71, სართ2,  ოფისი 11. ვებ.გვერდი: WWW.DRC.GE.
            </Text>
             
            <Text style={styles.p0}>
                <Text style={styles.b}>12.2. </Text>  მხარეები ვთანხმდებით, რომ მხარეებს შორის, ასევე საარბიტრაჟო დაწესებულება „დავების განმხილველი ცენტრს“ ს/კ 204547348 შორის კომუნიკაცია შესაძლებელია განხორციელდეს ელექტრონული ფორმით. ამ შემთხვევაში შეტყობინება განხორციელებულად ჩაითვლება, თუ იგი მხარეს ჩაბარდა ელექტრონული ფოსტის მეშვეობით. მხარეები თანხმობას აცხადებენ, რომ ხელშეკრულებით განსაზღვრულ ელ-ფოსტის მისამართზე ელექტრონული ფოსტის საშუალებით გაგზავნილი შეტყობინება მათთვის ჩაბარებულად ითვლება და აღნიშნულთან დაკავშირებით რაიმე სახის პრეტენზია არ ექნებათ.
            </Text>
              
            <Text style={styles.p0}>
                <Text style={styles.b}>12.3. </Text>  თუ დავის საგნის ღირებულება არ აღემატება 100 000 (ასი ათასი) ლარს  დავა მუდმივმოქმედ არბიტრაჟ „დავების განმხილველ ცენტრში“ (DRC)  განხილული იქნება ზეპირი მოსმენის გარეშე.
            </Text>
             

            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>13. </Text> მხარეთა შორის კომუნიკაცია
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>13.1. </Text>  მხარეთა შორის კომუნიკაცია, მათ შორის,  დოკუმენტაციის  ან/და ინფორმაციის მიმოცვლა ხორციელდება წინამდებარე ხელშეკრულებაში მითითებული საკონტაქტო რეკვიზიტებზე/მონაცემებზე  (ფაქტობრივი/რეგისტრირებული მისამართი, მობილური ტელეფონის ნომერი, ელექტრონული ფოსტა) შეტყობინების გაგზავნით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>13.2. </Text>  მხარე, რომელიც ცვლის (ან ეცვლება) საკონტაქტო რეკვიზიტებს/მონაცემებს ვალდებულია აღნიშნულის შესახებ გონივრულ ვადაში შეატყობინოს მეორე მხარეს, წინააღმდეგ შემთხვევაში ძველ რეკვიზიტებზე/მონაცემებზე გაგზავნილი შეტყობინება ნებისმიერ შემთხვევაში ჩაითვლება ჩაბარებულად.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>13.3. </Text>  თუ მხარე თავს არიდებს კურიერის/ფოსტის მეშვეობით გაგზავნილი შეტყობინების მიღებას (უარს ამბობს შეტყობინების ჩაბარებაზე ან ქმნის ისეთ ვითარებას, რა დროსაც კურიერი/ფოსტა ვერ ახერხებს შეტყობინების ჩაბარებას), შეტყობინება ჩაბარებულად ჩაითვლება მეორე შეტყობინების ჩაუბარებლობის მომდევნო დღიდან. 
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>13.4. </Text>  ელექტრონული ფოსტის ან მობილური საკომუნიკაციო საშუალების მეშვეობით გაგზავნილი შეტყობინება ითვლება ჩაბარებულად გაგზავნის დღეს, გარდა იმ შემთხვევისა, როდესაც ადრესატი მხარე დაამტკიცებს, რომ მას შეტყობინება არ მიუღია.
            </Text>


 


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>14. </Text> კლიენტის პერსონალური მონაცემების დამუშავება
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>14.1. </Text>  კლიენტი წინამდებარე ხელშეკრულებაზე ხელმოწერით თანხმობას აცხადებს კომპანიამ მისი პერსონალური მონაცემები დაამუშავოს პირდაპირი მარკეტინგის მიზნებისთვის, კერძოდ, კლიენტი თანხმობას აცხადებს {ltd}-სგან, მათ შორის, მის დამუშავებაზე უფლებამოსილი პირებისაგან - {ltd}-ს სახელით ან {ltd}-ს დაკვეთით მოქმედი პირებისაგან, პერიოდულად მიიღოს მოკლე ტექსტური შეტყობინებები (SMS), ტექსტური, ხმოვანი, ელექტრონული და სხვა სახის შეტყობინებები, მათ შორის, ხმოვანი სატელეფონო ზარები, ტელეფონის, ფოსტის, ელექტრონული ფოსტის, სოციალური ქსელების ან სხვა ელექტრონული საშუალებით, {ltd}-ს ან/და {ltd}-ს  საქონლის/პროდუქტის, იდეის, მომსახურების, ფასდაკლების, აქციის, წამოწყების, წამახალისებელი ან სხვა გათამაშებების, პროექტების ან/და {ltd}-ს პარტნიორი ორგანიზაციების ერთობლივი პროექტების თაობაზე, ასევე მიიღოს  დაბადების დღის, დღესასწაულებისა და სხვა მნიშვნელოვანი და ღირსშესანიშნავი თარიღების თაობაზე მილოცვები, ინფორმაცია {ltd}-ში არსებული სამუშაოებისა და ვაკანსიების თაობაზე, ასევე, სხვა ნებისმიერი სახის სარეკლამო/მარკეტინგული შეთავაზებები.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>14.2. </Text>  კლიენტი წინამდებარე ხელშეკრულებაზე ხელმოწერით ასევე თანხმობას აცხადებს, რომ კომპანიის მიერ მზღვეველისათვის წარდგენილ კლიენტის საკონტაქტო ტელეფონის ნომრისა და ელექტრონული ფოსტის მისამართებზე მზღვეველისგან მიიღოს სადაზღვევო ხელშეკრულებით გათვალისწინებულ მომსახურებასთან დაკავშირებული სხვადასხვა - მათ შორის პირდაპირ მარკეტინგთან დაკავშირებული, განსაკუთრებული მონაცემების შემცველი შეტყობინებები. კლიენტი ადასტურებს, რომ მითითებული მიზნით მისი პერსონალური მონაცემების დამუშავებასთან დაკავშირებით პრტენზიები არ ექნება არც კომპანიასთან და არც დამზღვევთან.
            </Text>

                 <Text style={styles.p0}>
                    <Text style={styles.b}>14.3. </Text>  კლიენტი წინამდებარე ხელშეკრულებაზე ხელმოწერით ასევე თანხმობას აცხადებს, რომ კომპანიის მიერ მზღვეველისათვის წარდგენილ კლიენტთა საკონტაქტო ტელეფონის ნომრებსა და ელექტრონული ფოსტის მისამართებზე მზღვეველისგან მიიღოს შეტყობინებები პირდაპირი მარკეტინგის მიზნებისთვის ან მზღვეველმა კლიენტის პერსონალური მონაცემები გადასცეს მასთან აფილირებულ/დაკავშირებულ კომპანიებს პირდაპირი მარკეტინგის მიზნებისთვის. კლიენტი ადასტურებს, რომ მითითებული მიზნით მისი პერსონალური მონაცემების დამუშავებასთან დაკავშირებით პრტენზიები არ ექნება;
                </Text>
            
                        {shouldShowMarketingConsentClause(car.purchased_at) && (
                        <>
                                       <Text style={styles.p0}>
                                           <Text style={styles.b}>14.4. </Text>   კლიენტისათვის ცნობილია, რომ პერსონალურ მონაცემების დამუშავებაზე ამ პუნქტით განსაზღვრული თანხმობის გამოხმობა/პერსონალურ მონაცემთა დამუშავების შეწყვეტის მოთხოვნა (უარი) შეუძლია შემდგომში განაცხადოს  ნებისმიერ დროს, მოკლე ტექტური შეტყობინების (SMS) გაგზავნის მეშვეობით, ამ მიზნით მონაცემთა დამუშავების შეწყვეტის მოთხოვნის (უარის) განხორციელება კლიენტს შეუძლია კომპანიის შეტყობინების პასუხად SMSOFF, STOPSMS ან იმ სხვა ციფრ(ებ)ის/ტექსტის გაგზავნის საშუალებით, რომელიც მოკლე ტექსტურ შეტყობინებას ახლავს და ა.შ გამონაკლისის სახით, კლიენტის სათანადო იდენტიფიცირების პირობებში, პირდაპირი მარკეტინგის მიზნით პერსონალურ მონაცემთა დამუშავებაზე თანხმობის გამოხმობა/პერსონალურ მონაცემთა დამუშავების შეწყვეტის მოთხოვნა (უარი) კლიენტს შეუძლია განაცხადოს კომპანიის საჯაროდ ცნობილი  საკომუნიკაციო არხებზე მომართვის საშუალებით.
                                       </Text>
                       
                                       <Text style={styles.p0}>
                                           <Text style={styles.b}>14.5. </Text>  კლიენტი აცხადებს უპირობო და გამოუხმობ თანხმობას კომპანიამ საკუთარი სერვისის/მომსახურების რეკლამირების მიზნით შესაბამისი სარეკლამო/მარკეტინგული მასალების (მათ შორის, აუდიო-ვიდეო მასალების) დამზადებისას გამოიყენოს წინამდებარე ნასყიდობის ხელშეკრულების საგანი, მოახდინოს მისი აღბეჭდვა სარეკლამო/მარკეტინგულ მასალებში მათი შემდგომი გავრცელების (ეთერში გადაცემა, რეპორდუცირება, რეპროგრაფიული გამრავლება, საჯარო გადაცემა, საჯარო ჩვენება და ა.შ.) მიზნით. ნებისმიერ ასეთ სარეკლამო/მარკეტინგულ მასალებზე საავტორო და მომიჯნავე უფლებები ეკუთვნის კომპანიას.
                                       </Text>
                                      </>
                                   )}
            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
                <Text style={styles.b}>15. </Text> დასკვნითი დებულებები
            </Text> 

            <Text style={styles.p0}>
                <Text style={styles.b}>15.1. </Text>  წინამდებარე ხელშეკრულებაში ცვლილებებისა და/ან დამატებების შეტანა ხორციელდება მხარეთა ურთიერთშეთანხმებით და წერილობითი ფორმით.
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>15.2. </Text>  მხარეთა შორის გაფორმებული ნებისმიერი სხვა ორმხრივი დოკუმენტი, რომელიც შედგენილია იმ დათქმით, რომ ის არის ამ ხელშეკრულების განუყოფელი ნაწილი, მოქმედებს წინამდებარე ხელშეკრულებასთან ერთად და ძალაშია მასთან ერთად.
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>15.3. </Text>
                ხელშეკრულების ყველა დანართი წარმოადგენს მის განუყოფელ ნაწილს და ძალაშია მასთან ერთად.
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>15.4. </Text>
                საკითხები, რომელიც არ არის დარეგულირებული წინამდებარე ხელშეკრულებით გადაწყდება საქართველოს მოქმედი კანონმდებლობით.
            </Text>

            <Text style={styles.p0}>
                <Text style={styles.b}>15.5. </Text>
                ხელშეკრულების რომელიმე დებულების ბათილად ცნობა არ გამოიწვევს ხელშეკრულების დანარჩენი დებულებების ბათილობას. 
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>15.6. </Text>
                წინამდებარე ხელშეკრულება, ასევე ამ ხელშეკრულებასთან დაკავშირებული ნებისმიერი შეთანხმება, დოკუმენტი, განცხადება, რომელიც გაფორმდება ან/და გაიცვლება მხარეთა შორის, გარდა ჩვეულებრივი (სველი წესით) ხელმოწერისა, ასევე შეიძლება გაფორმდეს დისტანციურ რეჟიმში მხარეთა მიერ მათ მიერ ხელმოწერილი ეგზემპლიარის მეორე მხარისთვის  ელექტრონული ფოსტით ან/და SMS-ით გაგზავნის და მეორე მხარის მიერ მისი მიღების დადასტურების გზით ან/და ნებისმიერი სხვა დისტანციური/ელექტრონული საშუალებით (მათ შორის, Signify-თ), რომელიც იძლევა მხარეთა მიერ ნების გამოვლენის, ნების მიღებისა და/ან ხელშეკრულებაზე ხელისმოწერის გადმოწმების/დადასტურების საშუალებას. 
            </Text>



            <Text style={styles.p0}>
                <Text style={styles.b}>15.7. </Text>
                ხელშეკრულება შედგენილია ქართულ ენაზე ორი თანაბარი იურიდიული ძალის მქონე ეგზემპლარად და მხარეთა მიერ ხელმოწერის შემდეგ თითოეული ეგზემპლარი გადაეცემათ მხარეებს.
            </Text>


            <Text style={styles.p0}>
                <Text style={styles.b}>15.8. </Text>
                წინამდებარე ხელშეკრულება მხარის მოთხოვნით შეიძლება დაიდოს უცხო ენაზე, თუმცა ხელშეკრულების ქართულ ვერსიასა და უცხოურ ვერსიას შორის წინააღმდეგობის შემთხვევაში, უპირატესობა მიენიჭება ქართულ ვერსიას. 
            </Text>
        </Page>

        <Page size="A4" style={styles.page}>


            
            <Text style={{ fontFamily: 'HelveticaBold', width: '100%', textAlign: 'center', fontSize: '10px', marginTop: '15px', marginBottom: '3px', }}>
               მხარეთა ხელმოწერები
            </Text> 
 
            <Text style={styles.p0}>
                კლიენტი ხელმოწერით აცხადებს და ადასტურებს, რომ გეცნო წინამდებარე ხელშეკრულებას, ხელშეკრულების ყველა პირობა წინასწარ არის შეთანხმებული მასთან და ამ პირობებთან დაკავშირებით არ გააჩნია შენიშვნები და პრეტენზიები კომპანიის მიმართ და არც მომავალში ექნება.
            </Text>
 
  
 
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#fff', padding: '30px 0px'  }}>
 
                <View style={{ width: '50%', padding: '5px 20px 5px 0px', borderRight: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კომპანია </Text>
                    <Text>{ltd}</Text>
                    <Text>ს/ნ:{sk}</Text>
                    <Text>მის: {address}</Text>
                    <Text>ტელ: {tel}</Text>
                    <Text>ელ-ფოსტა: {email}</Text>
                    <Text style={{ textAlign: 'left' }}>{director_position}: <Text style={{ fontFamily: 'HelveticaBold' }}> {director} (პ/ნ:{director_pn})</Text></Text>
                    <Text> </Text>
                    <Text>_______________________________________</Text>

                </View>
  
                <View style={{ width: '50%', paddingLeft: '20px', borderLeft: '1px solid '+ primaryColor}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>კლიენტი </Text>
                    <Text>{car.client.firstname} {car.client.lastname}  </Text>
                    <Text>პ/ნ: {car.client.personal} </Text>
                    <Text>ტელ: {car.client.mobile} </Text>
                    <Text>ელ-ფოსტა: {car.client.email} </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text> </Text>
                    <Text style={{ marginBottom: '5px' }}> </Text>
                    <Text>_______________________________________</Text>
                 </View>
  
            </View>


            <Text style={{ marginTop: '80px',textAlign: 'center', fontFamily: 'HelveticaBold'}}>
                (მხოლოდ იმ შემთხვევაში აწერთ აქ, თუ დაზღვევაზე უარს აცხადებთ)
            </Text>


            <Text style={{ marginBottom: '0px',textAlign: 'center',  }}>
                ჩემი სურვილით უარს ვაცხადებ წინამდებარე ხელშეკრულებით განსაზღვრული ავტომანქანის  გადაზიდვის (ტრანსპორტირების) დაზღვევაზე, რასაც ვადასტურებ ხელმოწერით
            </Text>
 

            <Text style={{ marginTop: '20px',textAlign: 'center',  }}>
                კლიენტი: ______________________
            </Text>
 



        </Page>
 

        <Page size="A4" style={styles.page}>
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'right', marginBottom: '5px',}}>
                <Text>დანართი N1</Text> 
            </View>

            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ავტომობილის დაზღვევის პირობები</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>სადაზღვევო პირობები, ვრცელდება იმ გარეგნულ მდგომარეობაზე, რაც ასახულია ტრანსპორტირების დაწყების მომენტში გადაღებულ ფოტოებზე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ზარალის განხილვა ხდება, ტრანსპორტირების დაწყებისას და მიმღებ პორტში კომპანიის წარმომადგენლის მიერ გადაღებული  ფოტოების შედარებით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>თუ დეტალი ექვემდებარება აღდგენას, ასეთ შემთხვევაში დაზიანების ანაზღაურება მოხდება მისი აღდგენისათვის საჭირო ოდენობით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>როდესაც დაზიანებული დეტალი არ ექვემდებარება აღდგენას, ზარალი ანაზღაურდება არაორიგინალი დეტალის ღირებულებით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>სავალდებულო ფრანშიზა განისაზღვრება ზარალის 5%, მინიმუმ 100 აშშ დოლარით.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>ზარალი განიხილება გონივრულ ვადაში, არა უმეტეს ერთი თვისა.</Text></View>
            
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ანაზღაურებას ექვემდებარება ავტომობილის შემდეგი დაზიანებები:</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>ბამპერი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ცხაური</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>ფრთა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>სახურავი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>საყრდენი ძელი ე.წ. სტოიკა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>საქარე მინა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>7.</Text><Text style={{textAlign: 'justify', }}>სარკე</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>8.</Text><Text style={{textAlign: 'justify', }}>კარი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>9.</Text><Text style={{textAlign: 'justify', }}>ფარი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>10.</Text><Text style={{textAlign: 'justify', }}>უკანა მაშუქი ე.წ. სტოპი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>11.</Text><Text style={{textAlign: 'justify', }}>საბარგული</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 20, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>12.</Text><Text style={{textAlign: 'justify', }}>ავტომობილის ძარის სხვა შემადგენელი დეტალები</Text></View>
                                                                                                                    
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>ანაზღაურებას არ ექვემდებარება ავტომობილის შემდეგი დაზიანებები:</Text> 
            </View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>როცა დაზიანებულ დეტალს ემატება დაზიანება</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>ავტომობილის ტექნიკური გაუმართაობა</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>აკუმულიატორი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>4.</Text><Text style={{textAlign: 'justify', }}>დანესტიანებული სალონის ქიმწმენდა, დაზიანებული სალონი</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>5.</Text><Text style={{textAlign: 'justify', }}>დაზიანება, რომლის აღმოფხვრა შესაძლებელია პოლირებით</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>6.</Text><Text style={{textAlign: 'justify', }}>ნაწილები და დეტალები, რომელიც მდებარეობს ძრავში, სალონში.მანქანის ქვედა მხარეს, ძირი, საბურავები, დისკები, ამორტიზატორები და სხვა სავალი ნაწილები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>7.</Text><Text style={{textAlign: 'justify', }}>დეტალები, რომლებიც არ ჩანს ვიზუალურად ფოტოებზე</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>8.</Text><Text style={{textAlign: 'justify', }}>მოტოციკლის , კვადროციკლების , თოვლის ყველგანმავლების დეტალები, პლასმასები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>9.</Text><Text style={{textAlign: 'justify', }}>დეტალები, რომლებიც არ არის ქარხნული წესით დამაგრებული, დაზიანების შედეგად ნახევრად მიმაგრებულია ან გარკვეულ წილად დაზიანებულია დამაგრების ადგილები ან თავად დეტალები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>10.</Text><Text style={{textAlign: 'justify', }}>ევაკუატორის მომსახურება და სხვა ხარჯები, რომელიც უკავშირდება გასაღების დაკარგვას</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>11.</Text><Text style={{textAlign: 'justify', }}>საბარგულის და სალონის ნოხები, რეზინის საფარები</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 30, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>12.</Text><Text style={{textAlign: 'justify', }}>ნაკაწრები</Text></View>
                                                                                                                    
            
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '20px', marginTop: '20px'}}>
                <Text>გამონაკლისები:</Text> 
            </View>


            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს ნებისმიერი საომარი იარაღის გამოყენებით, რომელიც მოიცავს ატომური ან ბირთვული დაშლის და/ან სინთეზის ან სხვა მსგავს რეაქციას ან რადიოაქტიურ ნივთიერებას ან გამოსხივებას
            </Text> 


            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს შეპყრობით, კონფისკაციით, ყადაღით, გადაადგილების აკრძალვით ან დაკავებით (გარდა მეკობრეობისა) და მათგან გამომდინარე შედეგებით ან ამ ქმედებების ნებისმიერი მცდელობით.
            </Text> 

            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს მიტოვებული ნაღმებით, ტორპედოებით, ბომბებით ან სხვა მიტოვებული საომარი იარაღით.
            </Text> 


            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ ფარავს დანაკარგს, დაზიანებას ან ხარჯს:
            </Text> 

            <Text style={styles.p}>
                გამოწვეულს გაფიცულთა ქმედებებით, ლოკაუტირებული მუშებით, ან იმ პიროვნებების ქმედებით, რომლებიც იღებენ მონაწილეობას შრომით არეულობებში, აჯანყებაში ან სამოქალაქო მღელვარებაში.
            </Text> 

            <Text style={styles.p}>
                გამოწვეულს გაფიცვებით, ლოკაუტით, შრომითი არეულობით, აჯანყებით ან სამოქალაქო მღელვარებით.
            </Text> 

            <Text style={styles.p}>
                გამოწვეულს ნებისმიერი ტერორისტული ან პოლიტიკური მოტივით მოქმედი პიროვნების/ების მიერ.
            </Text> 


            <Text style={styles.p}>
                არც ერთ შემთხვევაში ეს დაზღვევა არ დაფარავს დანაკარგს, დაზიანებას ან ხარჯს, გამოწვეულს გემის ან ხომალდის ნაოსნობისთვის გამოუსადეგარობით,
            </Text> 


            <Text style={styles.p}>
                გემის, ხომალდის, გადაზიდვის სხვა საშუალების, კონტეინერის ან სატვირთო ვაგონის შეუსაბამობით დაზღვეული ტვირთის უსაფრთხო გადაზიდვასთან.
            </Text> 


            <Text style={styles.p}>
                იმ შემთხვევაში, როცა დაზღვეული ტვირთის მათში ჩატვირთვის დროისათვის დაზღვეულისათვის ან მისი მომსახურე პერსონალისათვის ცნობილია ასეთი გამოუსადეგარობის ან შეუსაბამობის შესახებ.
            </Text> 

            <Text style={styles.p}>
                მზღვეველი არ მიიჩნევს ხომალდის ნაოსნობისათვის გამოსადეგობის და შესაბამისობის პირობის დარღვევად არც ერთ შემთხვევას, გარდა იმ შემთხვევებისა, როცა დაზღვეულისათვის ან მისი მომსახურე პერსონალისათვის ცნობილი იყო ასეთი გამოუსადეგარობისა და შეუსაბამობის შესახებ
            </Text> 

 
            <View style={{fontFamily: 'HelveticaBold', textAlign: 'right', marginBottom: '5px', marginTop: '270px',}}>
                <Text>დანართი N2</Text> 
            </View>

            <View style={{fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '5px', marginTop: '20px'}}>
                <Text>სადაზღვევო შემთხვევის დაფიქსირების ინსტრუქცია</Text> 
            </View>


            <Text style={styles.p}>
                იმისათვის, რომ მოხდეს სადაზღვევო შემთხვევის, პოლისით განსაზღვრული დაზიანების ანაზღაურება აუცილებელია დაკმაყოფილდეს შემდეგი პირობები:
            </Text> 

            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>1.</Text><Text style={{textAlign: 'justify', }}>ნებისმიერ შემთხვევაში სადაზღვევო შემთხვევის დაფიქსირება უნდა მოხდეს ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე. სადაზღვევო შემთხვევის შესახებ ინფორმაცია დაუყოვნებლივ და სრულად უნდა მიეწოდოს კომპანიის შესაბამის სამსახურს, ქვემოთ მითითებულ საკონტაქტო ნომრებზე.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>2.</Text><Text style={{textAlign: 'justify', }}>სადაზღვევო პირობებით განსაზღვრული დაზიანების არსებობის შემთხვევაში ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე, ასევე უნდა მოხდეს პორტის ადმინისტრაციაში აღნიშნულ ფაქტთან დაკავშირებით შესაბამისი სატერმინალო დაზიანების აქტის შედგენა და სატრანსპორტო საშუალების დასურათება.</Text></View>
            <View style={{ flexDirection: "row", marginBottom: 0, paddingRight: 10 }} ><Text style={{ maxWidth: 7, minWidth: 7, marginRight: 8 }}>3.</Text><Text style={{textAlign: 'justify', }}>ავტოსატრანსპორტო საშუალებაში მოთავსებული ნივთის, სათადარიგო საბურავის, ავტონაწილის ან/და გასაღების დაკარგვის/მოპარვის შემთხვევაში, ავტოსატრანსპორტო საშუალების პორტის ტერიტორიიდან გაყვანამდე, აუცილებელია მოხდეს საპატრულო პოლიციის გამოძხება ადგილზე აღნიშნული ფაქტის დასაფიქსირებლად.</Text></View>


                <View style={{ width: '100%', marginBottom: 10, marginTop: 30}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>ცხელი ხაზი: </Text>
                    <Text>{tel}</Text>
                    
                </View>

                <View style={{ width: '100%', marginBottom: 10}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>საკონტაქტო პირი ფოთში: </Text>
                    <Text>ლევან კარანაძე, ტელ: (+995) 577 39 60 60</Text>
                </View>

                {/* <View style={{ width: '100%', marginBottom: 10}}>
                    <Text style={{ fontFamily: 'HelveticaBold' }}>საკონტაქტო პირი ბათუმში: </Text> 
                    <Text>{director}, ტელ: (+995) 500 50 26 34</Text>
                </View> */}
               

            </Page>


    </Document>
);

const Contract = ({ carItem }) => {
    const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument t={t} car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'Contract.pdf';
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}> <PDFicon /> {t('Contract')} </span>
    );
};

export default Contract;
